// extracted by mini-css-extract-plugin
module.exports = {"twoColumnPageLayout__wrapper":"TwoColumnPageLayout_twoColumnPageLayout__wrapper__143Sm"};